























import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import * as Yt from '@shared/helpers/videoEmbeddings/youtube';
import { CSSClass } from '@shared/types/vue';
import { BaseButton } from '@shared/ui';

import PlayCircle from '~/static/icons/play-circle.svg?inline';

export default defineComponent({
  name: 'YoutubeVideoTile',
  components: {
    BaseButton,
    PlayCircle,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    expertLink: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isVideoPlaying = ref<boolean>(false);

    const expertProfileUrl = computed(() => props.expertLink.cached_url);
    const youtubeId = computed(() => props.video.content.youtube_video_id);
    const hasExpertLink = computed(() => !!props.expertLink.cached_url);

    const countdownDescriptionContainerClasses = computed<CSSClass[]>(() => {
      const youtubeButtonsClass = 'youtube-video-tile__buttons__btn';
      const youtubePlayButtonClass = 'youtube-video-tile__buttons__play-btn';
      const noExpertLinkClass = `${youtubePlayButtonClass}--no-expert`;

      return [
        youtubeButtonsClass,
        youtubePlayButtonClass,
        {
          [noExpertLinkClass]: !hasExpertLink.value,
        },
      ];
    });

    const lazyVideo = ref<Yt.LazyTubeInterface>();
    const playVideo = (): void => {
      lazyVideo.value?.handleClick();
      isVideoPlaying.value = !isVideoPlaying.value;
    };

    const youtubeLink = computed<Yt.EmbeddedAutoplayURL>(() => {
      const id: Yt.VideoId = youtubeId.value;
      return Yt.buildAutoPlayURL(id);
    });

    return {
      isVideoPlaying,
      playVideo,
      youtubeLink,
      expertProfileUrl,
      youtubeId,
      hasExpertLink,
      countdownDescriptionContainerClasses,
      lazyVideo,
    };
  },
});
